module.exports = __webpack_public_path__ + "img/P499205801.dd378ef3.jpg";